<script>
  import LoadingDots from './LoadingDots.svelte'

  let {
    message = 'Loading...',
    submessage = '',
    fullPage = false,
    class: className = '',
  } = $props()
</script>

<div
  class={fullPage
    ? `fixed inset-0 z-50 grid place-content-center bg-background/80 backdrop-blur-md ${className}`
    : `flex flex-col items-center justify-center gap-4 py-20 ${className}`}
>
  <div class="relative flex items-center justify-center">
    <div class="absolute inset-0 -m-4 rounded-full bg-primary/10 blur-xl animate-pulse"></div>
    <LoadingDots size="lg" class="relative text-primary" />
  </div>
  {#if message}
    <p class="text-sm font-medium text-foreground">{message}</p>
  {/if}
  {#if submessage}
    <p class="text-xs text-muted-foreground">{submessage}</p>
  {/if}
</div>
